import { ApiError } from '@anm/api';
import { DomainItem } from '@anm/api/modules/customDomains';
import { createAction, createAsyncAction } from '@anm/helpers/saga/typesafe-actions';

export const fetchDomainsList = createAction('wave.video/domains/FETCH_LIST')();

export const fetchDomainsListAsync = createAsyncAction(
  'wave.video/domains/FETCH_LIST_REQUEST',
  'wave.video/domains/FETCH_LIST_SUCCESS',
  'wave.video/domains/FETCH_LIST_FAILURE'
)<void, DomainItem[], ApiError>();

export const addNewDomain = createAction('wave.video/domains/ADD_NEW')<string>();

export const addNewDomainAsync = createAsyncAction(
  'wave.video/domains/ADD_NEW_REQUEST',
  'wave.video/domains/ADD_NEW_SUCCESS',
  'wave.video/domains/ADD_NEW_FAILURE'
)<string, string, ApiError>();

export const removeDomain = createAction('wave.video/domains/REMOVE')<string>();

export const removeDomainAsync = createAsyncAction(
  'wave.video/domains/REMOVE_REQUEST',
  'wave.video/domains/REMOVE_SUCCESS',
  'wave.video/domains/REMOVE_FAILURE'
)<string, string, ApiError>();
